import React from 'react';
import { StructureLeftRightWrapper } from '../../../MyTeamBackofficeStyled';
import { DotLineArrows } from '../../common';
import { useSelector } from 'react-redux';
import StructureNav from './StructureNav.js';
import { LevelZero } from './LevelZero/LevelZero.js';
import { Position } from '../../../myTeamBackOffice.constants';
import { LevelTwo } from '../common/LevelTwo/LevelTwo';

const StructureMobile = ({ selectTab }) => {
  const { rootTeamMemberTrading } = useSelector(
    (store) => store.myTeamBackoffice
  );

  return (
    <>
      <div>
        <LevelZero />
        <DotLineArrows />
        <StructureLeftRightWrapper style={{ marginBottom: '100px' }}>
          <div>
            <LevelTwo
              teamMember={rootTeamMemberTrading?.leftChildUser}
              parentId={rootTeamMemberTrading?.id}
              position={Position.L}
              selectTab={selectTab}
            />
            <DotLineArrows
              disabled={!rootTeamMemberTrading?.leftChildUser?.id}
            />
            <StructureLeftRightWrapper>
              <div>
                <LevelTwo
                  teamMember={
                    rootTeamMemberTrading?.leftChildUser?.leftChildUser
                  }
                  parentId={rootTeamMemberTrading?.leftChildUser?.id}
                  position={Position.L}
                  selectTab={selectTab}
                />
              </div>
              <div>
                <LevelTwo
                  teamMember={
                    rootTeamMemberTrading?.leftChildUser?.rightChildUser
                  }
                  parentId={rootTeamMemberTrading?.leftChildUser?.id}
                  position={Position.R}
                  selectTab={selectTab}
                />
              </div>
            </StructureLeftRightWrapper>
          </div>
          <div>
            <LevelTwo
              teamMember={rootTeamMemberTrading?.rightChildUser}
              parentId={rootTeamMemberTrading?.id}
              position={Position.R}
              selectTab={selectTab}
            />
            <DotLineArrows
              disabled={!rootTeamMemberTrading?.rightChildUser?.id}
            />
            <StructureLeftRightWrapper>
              <div>
                <LevelTwo
                  teamMember={
                    rootTeamMemberTrading?.rightChildUser?.leftChildUser
                  }
                  parentId={rootTeamMemberTrading?.rightChildUser?.id}
                  position={Position.L}
                  selectTab={selectTab}
                />
              </div>
              <div>
                <LevelTwo
                  teamMember={
                    rootTeamMemberTrading?.rightChildUser?.rightChildUser
                  }
                  parentId={rootTeamMemberTrading?.rightChildUser?.id}
                  position={Position.R}
                  selectTab={selectTab}
                />
              </div>
            </StructureLeftRightWrapper>
          </div>
        </StructureLeftRightWrapper>
      </div>

      <StructureNav selectTab={selectTab} />
    </>
  );
};

export default StructureMobile;
